<script setup lang="ts">
import MainSidebar from '@/app/components/MainSidebar.vue';
</script>

<template>
	<MainSidebar />
</template>
